// MainLayout.tsx
import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Top from "../../container/main/Top";
import SidebarMenu from "../../component/SidebarMenu";
import Footer from "./Footer";

const MainLayout: React.FC = () => {
	const [menuOpen, setMenuOpen] = useState(false);
	const location = useLocation();

	const hideFooter = ["/login", "/writeNew"].includes(location.pathname);

	return (
		<div className="App">
			<Top onMenuClick={() => setMenuOpen(true)} />
			<SidebarMenu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />

			{/* 🔥 Topbar 프레임 */}
			<div className="PageFrame">
				<div className="ContentsBody">
					<Outlet />
				</div>

				{/* Footer도 프레임 안에 */}
				{!hideFooter && <Footer />}
			</div>
		</div>
	);
};

export default MainLayout;
